import React from "react";
import { Row, Col, Image, Grid } from "antd";
import MenuButton from "../components/menu-button";
import { HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import AppLayout from "../layout/app-layout";
import { useTranslation } from "react-i18next";
import RecommendCard from "./home/recommend-card";
import YoutubeClip from "./home/youtube-clip";

const { useBreakpoint } = Grid;

const Home = ({ user }) => {
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <AppLayout
        currentPage={t("app-header.title-1")}
        user={user}
        GetIconNav={<HomeOutlined style={{ fontSize: "24px" }} />}
        screens={screens}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Image src="/home-banner.svg" preview={false} width="100%" alt="Main Content Image" />
          </Col>
        </Row>
        <MenuButton screens={screens} navigate={navigate} t={t} />
        <RecommendCard t={t} navigate={navigate} />
        <YoutubeClip />
      </AppLayout>
    </>
  );
};

export default Home;
